// extracted by mini-css-extract-plugin
module.exports = {"btn-primary":"_heading_btn-primary__GPZpL","main":"_heading_main__gmc0-","section":"_heading_section__eFep0","sub-heading":"_heading_sub-heading__3-hBN"};